
import React from 'react';
import { StrategyCard } from '../StrategyCard';
import { Strategy } from '../types';

interface StrategyListProps {
  strategies: Strategy[];
  isExpanded: boolean;
  onResearch: (strategyId: string) => void;
  onDeleteClick: (strategyId: string) => void;
  onStrategyClick: (strategy: Strategy) => void;
  selectedStrategy: string;
}

export const StrategyList: React.FC<StrategyListProps> = ({
  strategies = [], // Default to empty array if undefined
  isExpanded,
  onResearch,
  onDeleteClick,
  onStrategyClick,
  selectedStrategy
}) => {
  // Safely check if strategies exists and has length
  if (!strategies || strategies.length === 0) return null;
  
  return (
    <div className="space-y-3 sm:space-y-4">
      {strategies.map((strategy, index) => {
        // Skip any invalid strategy items (missing id or other critical properties)
        if (!strategy || !strategy.id) {
          console.warn(`Strategy at index ${index} is invalid:`, strategy);
          return null;
        }
        
        return (
          <StrategyCard
            key={strategy.id}
            strategy={strategy}
            isExpanded={isExpanded}
            onResearch={onResearch}
            onDeleteClick={onDeleteClick}
            onStrategyClick={onStrategyClick}
            selectedStrategy={selectedStrategy}
          />
        );
      })}
    </div>
  );
};
